export default "__VITE_ASSET__ea094ec7__"